import { DataTypes } from "../../../data/DataManager";
import { EMPTY_VALUE, FieldSchema } from "../../../Schema";
import { isUserValue } from "../../common/external-sources/Users";

export const currentUser: FieldSchema = {
  name: "currentUser",
  display: { displayed: false },
  graphql: { selection: undefined },
  dataTransform: {
    general: {
      getter: async ({ currentUser }) => {
        if (isUserValue(currentUser)) {
          return {
            id: currentUser.id,
            userId: currentUser.user || currentUser.userId,
            email: currentUser.email,
            name: currentUser.name,
            givenName: currentUser.givenName,
            familyName: currentUser.familyName,
            isAdmin: currentUser.isAdmin,
            site: currentUser.site,
          };
        }
        return EMPTY_VALUE;
      },
    },
    // Never persisted, by either route: this exists to drive the form and the schema's
    // own cross-field logic, not to be stored.
    toGraphql: undefined,
    toDb: undefined,
  },
  data: { type: DataTypes.OBJECT },
  form: { disabled: true, displayed: false },
};
